const MAX_SIDE_PX = 4096;
const MAX_UPSCALE = 2;

export function rasterScale(width: number, height: number): number {
	return Math.min(MAX_UPSCALE, MAX_SIDE_PX / Math.max(width, height, 1));
}

export async function rasterizeSvg(svgDataUri: string, width: number, height: number): Promise<string> {
	const image = new Image();
	image.src = svgDataUri;
	await image.decode();

	const scale = rasterScale(width, height);
	const canvas = document.createElement('canvas');
	canvas.width = Math.max(1, Math.round(width * scale));
	canvas.height = Math.max(1, Math.round(height * scale));

	const context = canvas.getContext('2d');
	if (!context) throw new Error('Le fond du plan n’a pas pu être préparé.');

	context.drawImage(image, 0, 0, canvas.width, canvas.height);

	return canvas.toDataURL('image/png');
}
